<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box bgffffff">
      <el-form size='mini' :model="ruleForm" :rules="rules" ref="ruleForm" label-position='right' label-width="120px">
        <el-row>
          <el-col :span="24" v-if="type">
            <el-form-item prop="shopsId" label="所属商铺">
              <el-select clearable v-model="ruleForm.shopsId" multiple placeholder="请选择" style="width:30%">
                <el-option v-for="item in BusinessList" :key="item.id" :label="item.fulName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!type">
            <el-form-item prop="merchantId" label="所属商铺">
              <el-select clearable v-model="ruleForm.merchantId" placeholder="请选择" style="width:30%">
                <el-option v-for="item in BusinessList" :key="item.id" :label="item.fulName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="commodityTypeId" label="商品分类">
              <el-select v-model="ruleForm.commodityTypeId" placeholder="请选择" style="width:30%">
                <el-option v-for="item in CommodityClassificationLIst" :key="item.id" :label="item.commodityType" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop='picturePath' label="商品图片">
              <MoreUpload ref="MoreUpload" v-model="ruleForm.picturePath" v-if="ruleForm.picturePath" />
              <div>建议尺寸:800*800，支持jpg、jpeg、png格式图片</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="commodityName" label="商品名称">
              <el-input v-model="ruleForm.commodityName" style="width:30%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="sort" label="排序(越小越靠前)">
              <el-input v-model="ruleForm.sort" style="width:30%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品详情">
              <Editor v-model="ruleForm.html" ref="Editor" />
              <el-table :data="tableData" style="width:60%">
                <el-table-column prop="specifications" label="型号/规格" width="180">
                  <template slot-scope="{row}">
                    <el-input v-model="row.specifications" placeholder="请输入型号/规格" />
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="零售（元）" width="180">
                  <template slot-scope="{row}">
                    <el-input v-model="row.money" placeholder="请输入零售价" />
                  </template>
                </el-table-column>
                <el-table-column prop="stock" label="库存" width="180">
                  <template slot-scope="{row}">
                    <el-input v-model="row.stock" placeholder="请输入库存" />
                  </template>
                </el-table-column>
                 <el-table-column prop="astrict" label="起购量" width="180">
                  <template slot-scope="{row}">
                    <el-input v-model="row.astrict" placeholder="请输入起购量" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="danger" icon="el-icon-delete" circle @click="delItem(scope)"></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="state" label="上/下架">
                  <template slot-scope="{row}">
                    <el-switch v-model="row.state" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="2" />
                  </template>
                </el-table-column>
                <el-table-column prop="picture" label="图片">
                  <template slot-scope="{row}">
                    <UploadAvatar v-model="row.picture" :hide='row.picture?true:false' />
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" style="marginTop:20px" @click="addItem">新增规格</el-button>
              <el-button v-if="!type" type="primary" style="marginTop:20px" plain @click="saveItem">保存新规格</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="preservation" v-preventReClick>确认保存</el-button>
              <el-button @click="go">返回列表</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import MoreUpload from '@/components/MoreUpload'
// import CropperUpload from '@/components/CropperUpload'
import UploadAvatar from '@/components/UploadAvatar'
import Editor from '@/components/Editor'
export default {
  name: 'AddItem',
  components: { MoreUpload, Editor, UploadAvatar },
  data() {
    return {
      tableData: [
        {
          specifications: null, //型号规格
          money: null, //价格
          stock: null, //库存
          astrict:1,//起购量
          state: 1, //1-上架 2-下架
        }
      ],
      CommodityClassificationLIst: [],//商品分类列表
      BusinessList: [], //商户列表
      type: true,
      ruleForm: {
        shopsId: null, //多选商铺Id
        merchantId: null,//商铺ID
        commodityTypeId: null, //商品类别Id
        picturePath: null, //图片路径
        commodityName: null, //商品名称
        sort: null, //排序
        html: null, //富文本页面
      },
      rules: {
        commodityTypeId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        merchantId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        shopsId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        picturePath: [
          { required: true, message: '请选择图片并上传服务器', trigger: 'blur' }
        ],
      }
    }
  },
  computed: {},
  created() {
    this.getProductIntroduction()
  },
  beforeMount() {
    this.$nextTick(() => {
      this.$refs.ruleForm.clearValidate()
    })
  },
  mounted() {
    this.getBusiness()
    this.getCommodityClassificationLIst();
  },
  methods: {
    addItem() {
      this.$set(this.tableData, this.tableData.length, {
        specifications: null, //型号规格
        picture: null,
        money: null, //价格
        stock: null, //库存
        astrict:1,//起购量
        state: 1, //1-上架 2-下架
      })
    },
    // 保存规格
    saveItem(){
      let newSpecification=[]
      this.tableData.forEach(item=>{
        if(!item.id){
          newSpecification.push(item)
        }
      })
      this.$Commodity.addCommoditySpecifications({
        id: this.$route.query.id,
        specifications:newSpecification
      }).then(({data})=>{
        if(data.code==200){
          this.$message.success(data.message)
          this.getProductIntroduction()
        }else{
          this.$message.error(data.message)
        }
      })
    },
    delItem(data) {
      let { $index } = data;
      this.tableData.splice($index, 1)
    },
    //获取商品详情
    getProductIntroduction() {
      if (this.$route.query.type == '2') {
        this.type = false
        this.$Commodity.queryCommodityId({ id: this.$route.query.id }).then(({ data }) => {
          if (data.code === 200) {
            Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = data.result[item])
            this.tableData = data.result['specifications']
          }
        })
      } else {
        this.type = true
        this.ruleForm.picturePath = []
        return false
      }
    },
    //获取商品分类列表
    getCommodityClassificationLIst() {
      this.$Commodity.list().then(({ data }) => {
        if (data.code === 200) {
          this.CommodityClassificationLIst = data.result
        }
      })
    },
    preservation() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let { picturePath, ...obj } = this.ruleForm
          let url = picturePath.reduce((total, item) => {
            total += item + '|'
            return total
          }, '').slice(0, -1)
          if (this.$route.query.type == '1') {
            this.$Commodity.releaseGoods({ picturePath: url, ...obj, specifications: this.tableData }).then(({ data }) => {
              if (data.code === 200) {
                this.messages(data.message, true, 1000)
                Object.keys(this.ruleForm).forEach(item => {
                  if (item != 'shopsId' && item != 'commodityTypeId') {
                    this.ruleForm[item] = null
                  }
                })
                this.ruleForm.picturePath = []
                this.$refs.Editor.clear()
                this.$refs.MoreUpload.clear()
                this.tableData = [{
                  specifications: null, //型号规格
                  picture: null,
                  money: null, //价格
                  stock: null, //库存
                  astrict:1,//起购量
                  state: 1, //1-上架 2-下架
                }]
              }
            })
          } else if (this.$route.query.type == '2') {
            this.type = false
            this.$Commodity.updateCommodity({ picturePath: url, ...obj, specifications: this.tableData, id: this.$route.query.id }).then(({ data }) => {
              if (data.code === 200) {
                this.messages(data.message, true, 1000)
              }
            })
          }
        }
      });
    },
    //获取商户列表
    getBusiness() {
      this.$MerchantManagement.total().then(({ data }) => {
        if (data.code === 200) {
          this.BusinessList = data.result
        }
      })
    },
    //返回商品列表
    go() {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped>
.main-min-height {
  min-height: calc(100vh - 74px);
}
</style>
